import CTASection from "@/components/CTASection";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const VALUES = [
  { n: "01", t: "Outcomes over outputs", d: "We measure ourselves on the results we generate for clients, not the volume of work we produce." },
  { n: "02", t: "One team, one plan", d: "Media, creative, brand and web operate as a single team behind one strategy for each client." },
  { n: "03", t: "Direct and clear", d: "No jargon, no fluff. Straight advice, straight reporting, straight to the point." },
  { n: "04", t: "Long-term partners", d: "We build relationships that last, because compounding growth needs continuity." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO title="About" description="A small team of creative, strategic people helping New Zealand businesses grow." />
      <section className="pt-16 pb-20 lg:pt-24">
        <div className="ob-container">
          <h1 className="ob-h1 max-w-5xl">We're a small team who believe marketing doesn't need to be complicated to be great.</h1>
        </div>
      </section>

      <section className="pb-24">
        <div className="ob-container grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-[var(--ob-bg-alt)]">
              <img src="/images/onboard/about-hero.jpg" alt="Onboard Marketing" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="ob-eyebrow mb-4">Our story</div>
            <p className="ob-lead">
              Onboard Marketing sits inside the wider Onboard business, a small group of specialists who quietly support New Zealand business owners across lending, accounting, insurance and marketing.
            </p>
            <p className="ob-lead mt-6">
              We started this team because we kept seeing the same thing: really good businesses stuck with marketing that felt disconnected from the rest of what they were doing. Templated, transactional, and rarely tied back to real outcomes.
            </p>
            <p className="ob-lead mt-6">
              So we built something a bit different. A small, thoughtful team that treats every client's marketing the way we'd want ours treated, with genuine care, honest advice, and work we're actually proud to put our name to.
            </p>
          </div>
        </div>
      </section>

      <section className="ob-section" style={{ background: "var(--ob-bg-alt)" }}>
        <div className="ob-container">
          <div className="ob-eyebrow mb-4">Our values</div>
          <h2 className="ob-h2 mb-14 max-w-4xl">The principles behind everything we do.</h2>
          <div className="grid md:grid-cols-2 gap-x-16 gap-y-14">
            {VALUES.map((v) => (
              <div key={v.n} className="border-t border-[var(--ob-border)] pt-6">
                <div className="text-[13px] tracking-[0.14em] uppercase" style={{ color: "var(--ob-muted)" }}>{v.n}</div>
                <h3 className="ob-h3 mt-3">{v.t}</h3>
                <p className="ob-body mt-4 max-w-xl">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ob-section">
        <div className="ob-container grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="ob-eyebrow mb-4">Our approach</div>
          </div>
          <div className="lg:col-span-8">
            <p className="ob-lead">
              We start every engagement with a clear picture of what "growth" looks like for your business. From there, we build a strategy that combines the channels most likely to deliver, and only the channels most likely to deliver.
            </p>
            <p className="ob-lead mt-6">
              We report against the outcomes that matter to your business. Not marketing metrics. Not vanity numbers. Revenue, pipeline, cost per outcome and lifetime value.
            </p>
            <div className="mt-10">
              <Link to="/contact" className="ob-btn ob-btn-primary">Book a strategy call</Link>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
